var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCeMarkLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6767_48796)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6 11.9699C6.40063 11.99 6.20038 12 6 12C4.4087 12 2.88258 11.3679 1.75736 10.2426C0.632141 9.11742 0 7.5913 0 6C0 4.4087 0.632141 2.88258 1.75736 1.75736C2.88258 0.632141 4.4087 0 6 0C6.20038 -5.7686e-09 6.40063 0.0100377 6.6 0.0300754V1.83008C6.40097 1.80574 6.20046 1.79569 6 1.8C4.88609 1.8 3.8178 2.2425 3.03015 3.03015C2.2425 3.8178 1.8 4.88609 1.8 6C1.8 7.11391 2.2425 8.18219 3.03015 8.96985C3.8178 9.7575 4.88609 10.2 6 10.2C6.20046 10.2043 6.40097 10.1943 6.6 10.1699V11.9699Z",
    fill: "#18181A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7992 11.9699C16.5998 11.99 16.3996 12 16.1992 12C14.6079 12 13.0818 11.3679 11.9566 10.2426C10.8314 9.11742 10.1992 7.5913 10.1992 6C10.1992 4.4087 10.8314 2.88258 11.9566 1.75736C13.0818 0.632141 14.6079 0 16.1992 0C16.3996 -5.7686e-09 16.5998 0.0100377 16.7992 0.0300754V1.83008C16.6002 1.80574 16.3997 1.79569 16.1992 1.8C15.2416 1.79992 14.3127 2.12709 13.5665 2.72728C12.8203 3.32747 12.3016 4.16463 12.0964 5.1H15.5992V6.9H12.0964C12.3016 7.83537 12.8203 8.67253 13.5665 9.27272C14.3127 9.87291 15.2416 10.2001 16.1992 10.2C16.3997 10.2043 16.6002 10.1943 16.7992 10.1699V11.9699Z",
    fill: "#18181A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6767_48796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.8,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeMarkLogo);
export default __webpack_public_path__ + "static/media/ce-mark-logo.73d0ae371642949f6302f3cbfb81abe1.svg";
export { ForwardRef as ReactComponent };